// extracted by mini-css-extract-plugin
export default {"not-found":"not-found--ZqwZP","notFound":"not-found--ZqwZP","message":"message--cbRrG"};